module.exports = __webpack_public_path__ + "img/image.6e259150.svg";